export const columnsData = (viewPartsDetail, viewModelDetail) => {
  return [
    {
      title: "Id",
      dataIndex: "vehId",
      key: "vehId",
      render: (_,record) => <div className="cursor-pointer" onClick={() =>viewPartsDetail(record)}>{record?.vehId}</div>,
    },
    {
      title: "IMEI",
      dataIndex: "imei",
      key: "imei",
      render: (_,record) => <div className="cursor-pointer" onClick={() =>viewPartsDetail(record)}>{record?.imei}</div>,
    },
    {
      title: "Vehicle Model",
      dataIndex: "modelName",
      key: "modelName",
      render: (_,record) => <div className="cursor-pointer" onClick={() =>viewModelDetail(record)}>{record?.modelName}</div>,
    },
    // {
    //   title: "Manufacturer Name",
    //   dataIndex: "manufacturerName",
    //   key: "manufacturerName",
    // },
    {
      title: "Manufacturer Date",
      dataIndex: "mfrDate",
      key: "mfrDate",
      align: "center",
    },
    {
      title: "Net Weight",
      dataIndex: "netWeight",
      key: "netWeight",
      align: "center",
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
    },
    // {
    //   title: "Dealership",
    //   dataIndex: "dealership",
    //   key: "dealership",
    // },
    // {
    //   title: "Owner",
    //   dataIndex: "owner",
    //   key: "owner",
    // },
    {
      title: "Chassis No",
      dataIndex: "vehChassisNo",
      key: "vehChassisNo",
      render: (_,record) => <div className="cursor-pointer" onClick={() =>viewPartsDetail(record)}>{record?.vehChassisNo}</div>,
    },
    {
      title: "Registration No",
      dataIndex: "vehRegNo",
      key: "vehRegNo",
    },
    {
      title: "Status",
      dataIndex: "operationStatus",
      key: "operationStatus",
    },
  ];
};
